<template>
  <div id="app">
    <div id="appContent">
      <div id="sidebar" v-if="this.$store.getters.isAuthenticated" :class="{opened: menuOpened}">
        <div class="d-flex flex-row justify-content-between align-items-center">
          <div id="logo">EIKYŌ</div>
          <div class="hidden-small">
            <font-awesome-icon v-if="!this.menuOpened" @click="openMenu()" icon="bars" />
            <font-awesome-icon v-else @click="closeMenu()" icon="times" />
          </div>
        </div>
        <div id="menuContent">
          <router-link class="sidebar-item" :class="{'router-link-exact-active' : this.$router.currentRoute.name == 'website'}" to="/"><font-awesome-icon icon="columns" /><span class="sidebar-item-label">Dashboard</span></router-link>
          <router-link class="sidebar-item" to="/account"><font-awesome-icon icon="user" /><span class="sidebar-item-label">My account</span></router-link>
          <a target="_blank" href="https://www.eikyo.pro/Support.html" class="sidebar-item"><font-awesome-icon icon="question-circle" /><span class="sidebar-item-label">Support center</span></a>
          <div class="sidebar-item" v-on:click="logout();"><font-awesome-icon icon="sign-out-alt" /><span class="sidebar-item-label">Logout</span></div>
        </div>
      </div>
      <div id="pageContent">
        <router-view v-if="!loading"/>
        <div v-else>
          <font-awesome-icon icon="spinner" pulse />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'home',
  data: function() {
    return {
      menuOpened: false,
      loading: false,
    }
  },
  computed: {
    isAuthenticated: function () {
      return this.$store.state.token != undefined && this.$store.state.token != null &&  this.$store.state.token != ""; 
    }
  },
  methods: {
    logout: function() {
      this.$store.dispatch("AUTH_LOGOUT").then(() => {
        this.$router.push('/login')
      })
    },
    openMenu: function () {
      this.menuOpened = true;
    },
    closeMenu: function () {
      this.menuOpened = false;
    },
  },
  mounted:function() {
    if (this.isAuthenticated) {
      this.loading = true;
      var that = this;
      this.$store.dispatch("AUTH_INFOS").then(() => {
        that.loading = false;
      }).catch(() => {
        that.loading = false;
        that.$store.dispatch("AUTH_LOGOUT").then(function() {
          that.$router.push('/login')
        });
      });

    }
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css?family=Cabin:400,600,700|Playfair+Display:400,500,800&display=swap');

html {
  box-sizing: border-box;
}
*, *:before, *:after {
  box-sizing: inherit;
}
a, a:hover {
  text-decoration: none;
}

body {
  padding:0;
  margin:0;
}

html, body, #app {
  height: 100%;
}

::-webkit-scrollbar {
    background-color:#fff;
    width:16px
}

/* background of the scrollbar except button or resizer */
::-webkit-scrollbar-track {
    background-color:#F7F9FB;
}

/* scrollbar itself */
::-webkit-scrollbar-thumb {
    background-color:#babac0;
    border-radius:16px;
    border:4px solid #F7F9FB;
}

/* set button(top and bottom of the scrollbar) */
::-webkit-scrollbar-button {display:none}

#app {
  font-family: 'Cabin', Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

::placeholder {
  color:#b5b5b5;
}

#appContent {
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  position:absolute;
  top:0px;
  left:0px;
  right:0px;
  bottom:0px;
}

#sidebar {
  width: 240px;
  padding: 16px;
  box-shadow: -3px 0 20px 0 #e5e5e5;
}

#sidebar .sidebar-item-label {
  margin-left:24px;
}

#pageContent {
  flex-grow: 1;
  overflow:auto;
  padding:32px;
  background: #F7F9FB;
  text-align:left;
}

#nav {
  padding: 16px;
  display: flex;
  align-items: center;
  height:60px;
  overflow: hidden;
  z-index: 1;
  position: absolute;
  width: 100%;
  justify-content: space-between;
}

.nav-button {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 32px;
  border: solid 1px #e5e5e5;
  font-size: 1rem;
  margin-left: 16px;
}

.nav-button:hover {
  cursor:pointer;
  background: #e5e5e5;
}

#sidebar .sidebar-item {
  font-family: 'Cabin', Helvetica, sans-serif;
  font-weight: bold;
  color: #b9b9b9;
  padding: 16px 24px;
  text-decoration: none;
  display:block;
  text-align: left;
  display:flex;
  align-items: center;
}

#sidebar .sidebar-item:hover {
  cursor:pointer;
  color:#717f8e;
}
#sidebar .sidebar-item img {
  width:24px;
  margin-right: 8px;
}

#sidebar .sidebar-item.router-link-exact-active svg {
  color: #717bef;
}

#sidebar .sidebar-item.router-link-exact-active .sidebar-item-label {
  color: #2c3e50;
}

#logo {
  font-family: oskar-inline;
  font-weight: 400;
  font-size: 3rem;
  text-align: left;
}
#sidebar #logo {
  margin: 16px;
}

p {
  margin-bottom: 0;
}

h1, h2, h3, h4, h5 {
  margin:0;
  font-family: 'Playfair Display', Helvetica, Times, serif;
}

.flex {
  display:flex;
}

.items-center {
  align-items:center;
}

#app .black {
  color:black;
}

#app .card {
  border: none;
  border-radius: 8px;
  padding: 24px;
  text-align: left;
  border:solid 2px transparent;
  transition: border .2s;
  -webkit-transition: border .2s;
}

#app .card.hoverable:hover {
  background:#fdfdfd;
  border:solid 2px #bdc1ec;
  cursor:pointer;
}

#app .card.active, #app .card.active:hover {
  border:solid 2px #717bef;
}

#app .card.disabled {
  background: #ededf5;
}

#app .card {
  color:#2c3e50;
}
#app .card p {
  color:#858690;
  line-height: 1rem;
}

#app .card .ql-editor p {
  color:initial;
}

#app .ql-editor {
  padding:2rem;
}

.card h2 {
  font-size: 1.8rem;
}

#app .card h3 {
  font-size:1.25rem;
}

#app .text-big {
  font-size:1.75rem;
  color:black;
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background: linear-gradient(45deg, #5f68d4, #717bef);
  color: white;
  border-radius: 8px;
  box-shadow: 2px 3px 8px 0px #58585852;
  transition: .33s opacity;
  -webkit-transition: .33s opacity;
  border:none;
  outline:none!important;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 13px;
}

.button.button-secondary {
  background:linear-gradient(45deg, #d46b5f, #ef9671);
}

.button:hover {
  cursor:pointer;
  opacity:0.85;
  color:white
}

.button.button-transparent {
  background:transparent;
  box-shadow:none;
  color:#323031;
  padding:8px 0px;
}

.button.button-transparent:hover {
  color:#323031;
}

.button:not(.icon-only) svg {
  margin-right: 8px;
}

.modal-body {
  background:#F7F9FB;
}


#app label {
  display: block;
}

#app input, #app select {
  background: white;
  border: solid 1px #e1e1e1;
  padding: 8px 16px;
  border-radius: 8px;
  width:100%;
  outline:none;
}

#app select.small-input {
  width: 120px;
  margin-left: 0.5rem;
}

.success {
  color:#4CAF50;
}

.error {
  color:#FF5252;
}

.icon-img {
  width:24px!important;
}

.nav-pills .nav-link.active, .nav-pills .show>.nav-link {
    background-color: #717bef;
}

a {
  color:#717bef;
}

a:hover {
  color:#595fa9;
}

.options-icon {
  font-size:20px;
}

.w-64 {
  width:64px;
}

#app .dropdown-menu {
  padding:0px;
  overflow: hidden;
}

#app .dropdown-menu .dropdown-item {
  padding: 0.5rem 1rem;
  cursor: pointer;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #717bef;
}

input:focus + .slider {
  box-shadow: 0 0 1px #717bef;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

#app .tox .tox-statusbar{
  display:none;
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/* ANIMATIONS */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* GRAPH */ 

 .labels {
  stroke: rgba(0, 0, 0, 0.05);
}
 .active-line {
  stroke: rgba(0, 0, 0, 0.2);
}
 .point {
  stroke-width: 2;
  transition: stroke-width 0.2s;
}
 .point.is-active {
  stroke-width: 5;
}

.color-decline {
  color: #fbac91;
}

 .curve:nth-of-type(2) .stroke {
  stroke: #fbac91;
  stroke-width: 2;
}
 .curve:nth-of-type(2) .fill {
  fill: #fbac91;
  opacity: 0.15;
}
 .curve:nth-of-type(2) .point {
  fill: #fbac91;
  stroke: #fbac91;
}

.color-view {
  color:#2c3e50;
}
 .curve:nth-of-type(3) .stroke {
  stroke: #2c3e50;
  stroke-width: 2;
}
 .curve:nth-of-type(3) .point {
  fill: #2c3e50;
  stroke: #2c3e50;
}

.color-accept {
  color: #7fdfd4;
}

 .curve:nth-of-type(4) .stroke {
  stroke: #7fdfd4;
  stroke-width: 2;
}
 .curve:nth-of-type(4) .point {
  fill: #7fdfd4;
  stroke: #7fdfd4;
}
 .tooltip {
  padding: 10px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  pointer-events: none;
}
 .tooltip:not(.is-active) {
  display: none;
}
 .tooltip-data {
  display: flex;
}
 .tooltip-data-item {
  display: flex;
  align-items: center;
}
 .tooltip-data-item:not(:first-child) {
  margin-left: 20px;
}
 .tooltip-data-item:before {
  content: "";
  display: block;
  width: 15px;
  height: 15px;
  margin-right: 5px;
}
 .tooltip-data-item--1:before {
  background: #fbac91;
}

 .tooltip-data-item--2:before {
  background: #fbe1b6;
}
 .tooltip-data-item--3:before {
  background: #7fdfd4;
}



/* RESPONSIVE */
@media (min-width: 790px) {
  .hidden-small {
    display: none;
  }
}

@media (max-width: 789px) {
  #sidebar {
    position: absolute;
    top: 0px;
    z-index: 1;
    background: white;
    width: 100%;
  }

  #sidebar #logo {
    margin:0px;
  }

  #sidebar:not(.opened) #menuContent{
    display:none;
  }

  #pageContent {
    margin-top: 80px;
  }
}
</style>


